import React, { Component } from 'react';
import {
  IndicatorsLine,
  DivDetalhe,
  Linha,
  Labels,
  Line,
  SubContainer,
  SubContainerTitle,
} from './style';
import Skeleton from 'react-loading-skeleton';
import { getFromStorage } from '../../../services/auth';
import moment from 'moment';
import api from '../../../services/api';
import { alerta, formatOracleDateToBr } from '../../../services/funcoes';
import { Icon, Collapsible, CollapsibleItem } from 'react-materialize';
import ReactToPrint from 'react-to-print';
import ReportHeader from '../../ReportHeader';
import NoData from '../../NoData';

export class DownloadedAppReport extends Component {
  state = {
    // daySelected: new Date(),
    loading: false,
    changedFilter: 0,
  };

  componentDidMount = async () => {
    await this.carregarVariaveisEstado();
    this.handleAllDataUpdate();
    this.setState({ loading: true });
  };

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();
    //
    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
      empresaCfId: sessao.empresaCfId,
    });
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { changedFilter } = this.state;
    //
    //
    //
    //
    //
    //
    //
    if (this.props.changedFilter !== changedFilter) {
      //
      this.handleAllDataUpdate();
    }
  };

  loadDownloadedAppReport = async (startDate, finalDate, tipo) => {
    try {
      const { empresaAtiva, usuarioAtivo } = this.state;
      let vendedores, ramosAtividades, cidades;
      vendedores = this.getSelectedVendedores();
      ramosAtividades = this.getSelectedRamosAtividades();
      cidades = this.getSelectedCidades();

      //
      //
      //
      //
      //
      //

      const url =
        '/v1/dashboard/report/downloadedapp/' +
        empresaAtiva +
        '/' +
        usuarioAtivo;
      //
      let datas = {
        startDate,
        finalDate,
        cidades,
        ramosAtividades,
        vendedores,
        estruturaAutorizada: this.getEstruturaAutorizada(),
        tipo,
      };


      const retorno = await api.post(url, datas);



      if (!retorno) {
        return [];
      } else {
        if (retorno.data && retorno.data.sucess) {
          let result = retorno.data.data;
          let counter = 1;
          let geralCounter = 0;
          for (const route of result) {
            counter = 1;
            for (const cliente of route.clientes) {
              cliente.counter = counter;
              counter += 1;
              geralCounter += 1;
            }
          }

          this.setState({ geralCounter });
          return result;
        } else {
          return [];
        }
      }
    } catch (err) {
      //
      this.setState({ loading: false });
      alerta(`Erro ao carregar os indicadores => ` + err);
    }
  };

  getEstruturaAutorizada = () => {
    let inElements = '';

    if (this.props.estruturaAutorizada !== undefined) {
      for (const element of this.props.estruturaAutorizada) {
        inElements += "'" + element['ESTR_ID'] + "',";
      }

      if (inElements !== '') {
        return inElements.substr(0, inElements.length - 1);
      }
    }
    return inElements;
  };

  handleLoadDayData = async (daySelected) => {
    this.setState({ loading: true });

    //
    let downloadedApp = await this.loadDownloadedAppReport(
      moment(daySelected).format('DD/MM/yyyy'),
      moment(daySelected).format('DD/MM/yyyy'),
      'day'
    );
    //
    //
    this.setState({
      downloadedApp,
      loading: false,
    });
  };

  handleLoadMonthData = async (monthSelected) => {
    this.setState({ loading: true });
    //
    let startDate = moment(monthSelected).startOf('month').format('DD/MM/YYYY');
    let endDate = moment(monthSelected).endOf('month').format('DD/MM/YYYY');
    let downloadedApp = await this.loadDownloadedAppReport(
      startDate,
      endDate,
      'month'
    );
    this.setState({
      downloadedApp,
      loading: false,
    });
  };

  handleLoadCustomDataEnd = async (customSelectedEnd) => {
    this.setState({ loading: true });
    //
    let downloadedApp = await this.loadDownloadedAppReport(
      moment(this.props.customSelectedInitial).format('DD/MM/yyyy'),
      moment(customSelectedEnd).format('DD/MM/yyyy'),
      'custom'
    );

    this.setState({
      downloadedApp,
      loading: false,
    });
  };

  handleLoadCustomDataInitial = async (customSelectedInitial) => {
    this.setState({ loading: true });

    let downloadedApp = await this.loadDownloadedAppReport(
      moment(customSelectedInitial).format('DD/MM/yyyy'),
      moment(this.props.customSelectedEnd).format('DD/MM/yyyy'),
      'custom'
    );
    this.setState({
      loading: false,
      downloadedApp,
    });
  };

  handleAllDataUpdate = () => {
    this.setState({ loading: true });


    if (this.props.selectedFilter === 'day') {
      this.handleLoadDayData(this.props.daySelected);
    }
    if (this.props.selectedFilter === 'month') {
      this.handleLoadMonthData(this.props.monthSelected);
    }
    if (this.props.selectedFilter === 'custom') {
      this.handleLoadCustomDataInitial(this.props.customSelectedInitial);
    }
    let { changedFilter } = this.state;
    changedFilter =
      this.props.changedFilter !== undefined
        ? this.props.changedFilter
        : changedFilter;
    this.setState({ changedFilter, loading: false });
  };

  makeIn = (chipsElement, elements, searchText, searchKey) => {
    let inElements = '';
    if (chipsElement === undefined || elements === undefined) {
      return inElements;
    }
    for (const element of chipsElement) {
      const _element = elements.find(
        (elemento) => elemento[searchText] === element.tag
      );
      if (_element !== undefined) {
        if (!isNaN(_element[searchKey])) {
          inElements += _element[searchKey] + ',';
        } else {
          inElements += "'" + _element[searchKey] + "',";
        }
      }
    }
    if (inElements !== '') {
      return inElements.substr(0, inElements.length - 1);
    }
    return inElements;
  };

  getSelectedVendedores = () => {
    // let { vendedoresSelecionados, vendedores } = this.state;
    return this.makeIn(
      this.props.vendedoresSelecionados,
      this.props.vendedores,
      'VENDEDOR',
      'VENDEDOR_ID'
    );
  };

  getAllVendedores = () => {
    // const { vendedores } = this.state;
    let vendedoresFiltro = '';
    for (const vendedor of this.props.vendedores) {
      vendedoresFiltro += "'" + vendedor.VENDEDOR_ID + "',";
    }
    return vendedoresFiltro.substr(0, vendedoresFiltro.length - 1);
  };

  getSelectedRamosAtividades = () => {
    // let { ramosAtividadesSelecionados, ramosAtividades } = this.state;
    return this.makeIn(
      this.props.ramosAtividadesSelecionados,
      this.props.ramosAtividades,
      'RAMO',
      'RAMO_ID'
    );
  };

  getSelectedCidades = () => {
    // let { cidadesSelecionadas, cidades } = this.state;
    return this.makeIn(
      this.props.cidadesSelecionadas,
      this.props.cidades,
      'CIDADE',
      'CIDADE'
    );
  };

  getAllRamosAtividades = () => {
    // const { ramosAtividades } = this.state;
    let ramosAtividadesFiltro = '';
    for (const ramo of this.props.ramosAtividades) {
      ramosAtividadesFiltro += "'" + ramo.RAMO_ID + "',";
    }
    return ramosAtividadesFiltro.substr(0, ramosAtividadesFiltro.length - 1);
  };

  getAllCidades = () => {
    // const { cidades } = this.state;
    let cidadesFiltro = '';

    for (const cidade of this.props.cidades) {
      cidadesFiltro += "'" + cidade.CIDADE + "',";
    }
    return cidadesFiltro.substr(0, cidadesFiltro.length - 1);
  };

  getHeaderRoute = (route) => {
    return route.ESTR_COD_ROTA + ' - ' + route.ESTR_DESCR_ROTA;
  };

  render() {
    const { downloadedApp, loading, geralCounter } = this.state;
    return (
      <>
        <SubContainerTitle>{this.props.title}</SubContainerTitle>
        <SubContainer>
          {loading || this.props.loading ? (
            <Skeleton count={10} />
          ) : (
            <>
              {downloadedApp !== undefined && downloadedApp.length === 0 ? (
                <NoData />
              ) : (
                <>
                  {document.getElementsByTagName('body')[0].clientWidth <
                  768 ? (
                    <>
                      <Line style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        {downloadedApp !== undefined &&
                          downloadedApp.map((down) => (
                            <DivDetalhe
                              className="divDetalhe"
                              style={{ width: '100%' }}
                            >
                              <Collapsible
                                className="indicadorRotas"
                                accordion={false}
                                options={{
                                  inDuration: '0',
                                  outDuration: '0',
                                }}
                                style={{
                                  width: '100%',
                                  borderStyle: 'none',
                                  boxShadow: 'none',
                                }}
                              >
                                <CollapsibleItem
                                  key={down.ESTR_COD_ROTA}
                                  expanded={true}
                                  header={this.getHeaderRoute(down)}
                                  node="div"
                                >
                                  {down.clientes.map((cliente) => (
                                    <>
                                      <Linha
                                        style={{
                                          justifyContent: 'space-around',
                                          borderBottom: '1px solid #ccc',
                                          paddingBottom: '10px',
                                          marginBottom: '10px',
                                        }}
                                      >
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_CODIGO != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Código:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_CODIGO}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_RAZAO_SOCIAL != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Razão social:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_RAZAO_SOCIAL != null
                                                ? cliente.CLI_RAZAO_SOCIAL.toLowerCase()
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_NOME_FANTASIA != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Nome fantasia:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_NOME_FANTASIA != null
                                                ? cliente.CLI_NOME_FANTASIA.toLowerCase()
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_ENDERECO != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Endereço:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_ENDERECO != null
                                                ? cliente.CLI_ENDERECO.toLowerCase()
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_BAIRRO != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Bairro:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_BAIRRO != null
                                                ? cliente.CLI_BAIRRO.toLowerCase()
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_CIDADE != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Cidade:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_CIDADE != null
                                                ? cliente.CLI_CIDADE.toLowerCase()
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_UF != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              UF:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_UF != null
                                                ? cliente.CLI_UF
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_TELEFONE != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Telefone:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_TELEFONE != null
                                                ? cliente.CLI_TELEFONE
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CLI_TEL_CONTATO != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Contato:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CLI_TEL_CONTATO != null
                                                ? cliente.CLI_TEL_CONTATO
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                        <DivDetalhe
                                          style={{
                                            padding: '2px',
                                            border: '1px solid #ccc',
                                            borderRadius: '10px',
                                            margin: '3px',
                                            display:
                                              cliente.CCL_DATA_CADASTRO != null
                                                ? 'flex'
                                                : 'none',
                                          }}
                                        >
                                          <Linha style={{ cursor: 'pointer' }}>
                                            <Labels
                                              fontWeight={700}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              Data cadastro:
                                            </Labels>
                                            <Labels
                                              fontWeight={500}
                                              fontSize={0.8}
                                              style={{
                                                cursor: 'pointer',
                                                paddingRight: '2px',
                                              }}
                                            >
                                              {cliente.CCL_DATA_CADASTRO != null
                                                ? formatOracleDateToBr(
                                                    cliente.CCL_DATA_CADASTRO
                                                  )
                                                : ''}
                                            </Labels>
                                          </Linha>
                                        </DivDetalhe>
                                      </Linha>
                                    </>
                                  ))}
                                </CollapsibleItem>
                              </Collapsible>
                            </DivDetalhe>
                          ))}
                      </Line>
                    </>
                  ) : (
                    <>
                      <ReactToPrint
                        documentTitle={this.props.title}
                        onBeforeGetContent={() => {
                          this.setState({ imprimindo: true });
                        }}
                        onAfterPrint={() => {
                          this.setState({ imprimindo: false });
                        }}
                        trigger={() => {
                          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                          // to the root node of the returned component as it will be overwritten.
                          return (
                            <button className="saib-button is-primary">
                              <Icon>print</Icon>
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                      <IndicatorsLine ref={(el) => (this.componentRef = el)}>
                        <ReportHeader title={this.props.title} />

                        {downloadedApp !== undefined &&
                          downloadedApp.map((down) => (
                            <>
                              <Linha style={{ fontWeight: '600' }}>
                                {down.ESTR_COD_ROTA +
                                  ' - ' +
                                  down.ESTR_DESCR_ROTA}
                              </Linha>
                              <table
                                style={{
                                  fontSize: '0.8rem',
                                }}
                              >
                                <thead style={{ fontWeight: '600' }}>
                                  <tr>
                                    <th>Código</th>
                                    <th>Razão social</th>
                                    <th>Nome fantasia</th>
                                    <th>Endereço</th>
                                    <th>Bairro</th>
                                    <th>Cidade</th>
                                    <th>UF</th>
                                    <th>Telefone</th>
                                    <th>Tel.contato</th>
                                    <th>Dt.cadastro</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {down.clientes.map((cliente) => (
                                    <tr
                                      key={cliente.CLI_ID}
                                      className="linhaClientes"
                                      style={{
                                        backgroundColor:
                                          cliente.counter % 2 !== 0
                                            ? 'rgb(223, 178, 251)'
                                            : 'white',
                                      }}
                                    >
                                      <td id="indicator">
                                        {cliente.CLI_CODIGO}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_RAZAO_SOCIAL != null
                                          ? cliente.CLI_RAZAO_SOCIAL.toLowerCase()
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_NOME_FANTASIA != null
                                          ? cliente.CLI_NOME_FANTASIA.toLowerCase()
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_ENDERECO != null
                                          ? cliente.CLI_ENDERECO.toLowerCase()
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_BAIRRO != null
                                          ? cliente.CLI_BAIRRO.toLowerCase()
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_CIDADE != null
                                          ? cliente.CLI_CIDADE.toLowerCase()
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_UF != null
                                          ? cliente.CLI_UF
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_TELEFONE != null
                                          ? cliente.CLI_TELEFONE
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CLI_TEL_CONTATO != null
                                          ? cliente.CLI_TEL_CONTATO
                                          : ''}
                                      </td>
                                      <td id="indicator">
                                        {cliente.CCL_DATA_CADASTRO != null
                                          ? formatOracleDateToBr(
                                              cliente.CCL_DATA_CADASTRO
                                            )
                                          : ''}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <Linha
                                style={{
                                  width: '100%',
                                  marginBottom: '30px',
                                }}
                              >
                                <Labels
                                  color="#000000cf"
                                  fontWeight="500"
                                  fontSize="0.9rem"
                                >
                                  Qtde clientes: &nbsp;
                                </Labels>
                                <Labels
                                  color="#000000cf"
                                  fontWeight="500"
                                  fontSize="0.9rem"
                                >
                                  {down.TOTAL}
                                </Labels>
                              </Linha>
                            </>
                          ))}
                        <Linha
                          style={{
                            width: '100%',
                            marginBottom: '30px',
                          }}
                        >
                          <Labels
                            color="#000000cf"
                            fontWeight="500"
                            fontSize="0.9rem"
                          >
                            Total clientes: &nbsp;
                          </Labels>
                          <Labels
                            color="#000000cf"
                            fontWeight="500"
                            fontSize="0.9rem"
                          >
                            {geralCounter}
                          </Labels>
                        </Linha>
                      </IndicatorsLine>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </SubContainer>
      </>
    );
  }
}

export default DownloadedAppReport;
